// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { PATHWAYS_PAGES, PATHWAYS_SECTIONS } from "~shared-pathways";

import { TenantConfig } from "../core/models/types";
import enabledTableColumns from "../core/utils/enabledTableColumns";
import * as pathways from "../RootStore/TenantStore/pathwaysTenants";

const US_NY_CONFIG: TenantConfig<"US_NY"> = {
  name: "New York",
  stateCode: "NY",
  domain: "doccs.ny.gov",
  DOCName: "DOCCS",
  availableStateCodes: [pathways.US_NY],
  enableUserRestrictions: false,
  navigation: {
    // The order of pages here determines where the user will land first when navigating from `/`
    system: [PATHWAYS_PAGES.prison],
    prison: [
      PATHWAYS_SECTIONS.countOverTime,
      PATHWAYS_SECTIONS.countByLocation,
      PATHWAYS_SECTIONS.countByGender,
      PATHWAYS_SECTIONS.countBySex,
      PATHWAYS_SECTIONS.countByAgeGroup,
      PATHWAYS_SECTIONS.countByRace,
      PATHWAYS_SECTIONS.countByEthnicity,
      PATHWAYS_SECTIONS.countBySentenceLengthMin,
      PATHWAYS_SECTIONS.countBySentenceLengthMax,
      PATHWAYS_SECTIONS.countByChargeCountyCode,
      PATHWAYS_SECTIONS.countByOffenseType,
      PATHWAYS_SECTIONS.countByChargeDescription,
      PATHWAYS_SECTIONS.countByAdmissionReason,
      PATHWAYS_SECTIONS.countByReligion,
      PATHWAYS_SECTIONS.countByMaritalStatus,
      PATHWAYS_SECTIONS.countByTimeAtFacility,
    ],
    methodology: ["system"],
  },
  tableColumns: enabledTableColumns[pathways.US_NY],
};

export default US_NY_CONFIG;
